import React from 'react';
import { Button, Box, Typography } from '@mui/material';
import buttonEndIcon from '../../assets/icons/button-end.svg';

const CustomButton = ({ title, onClick, icon = true, backgroundColor, width }) => (
  <Button
    onClick={onClick}
    sx={{
      textTransform: 'none',
      background: backgroundColor || '#e41e25',
      color: 'white',
      borderRadius: '6px',
      boxShadow: '0px 4px 4px rgba(228, 30, 37, 0.25)',
      width: width || '290px',
      height: '50px',
      padding: '22px 44px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '20px',
      '&:hover': {
        background: '#d11920'
      }
    }}>
    <Typography fontFamily="gothamBold" fontSize="14px">
      {title}
    </Typography>
    {icon && (
      <Box
        component="img"
        src={buttonEndIcon}
        sx={{ width: 26, height: 26, display: 'flex', alignItems: 'center' }}
        alt="detail"
      />
    )}
  </Button>
);

export default CustomButton;
